import axios from "axios";

const basePoint = ".feedthetummy.com/api/";

export const getAPI = async (subdomain, URL) => {
  const GET_REQUEST = "https://" + subdomain + basePoint + URL;
  const { data } = await axios.get(GET_REQUEST);
  return data;
};

export const postAPI = async (subdomain, URL, Body, options = {}) => {
  const POST_REQUEST = "https://" + subdomain + basePoint + URL;
  const { data } = await axios.post(POST_REQUEST, Body, {
    headers: options.headers || {},
  });
  return data;
};
